exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".testResult h6[data-v-b30bd8ea]{font-size:1rem;font-weight:700}.testResult h6 svg[data-v-b30bd8ea]{fill:#f79e06}.testResult h6.success svg[data-v-b30bd8ea]{fill:#2cc561}.testResult ol[data-v-b30bd8ea]{padding-left:1.2rem}.testResult ol li img[data-v-b30bd8ea]{width:32px;margin:0 4px}", ""]);

// exports
